import Header from "@/components/politics/Header";
import Hero from "@/components/politics/Hero";
import {
  ProblemSection,
  PillarsSection,
  InstituteSection,
  FidelitySection,
  PersonasSection,
  LegalSection,
  BrasiliaSection,
  JourneySection,
  FAQSection,
} from "@/components/politics/Sections";
import LeadForm from "@/components/politics/LeadForm";
import Footer from "@/components/politics/Footer";

export default function PoliticsPage() {
  return (
    <main
      data-testid="politics-page"
      className="min-h-screen bg-[#F5FAFB] text-[#1B1D1D]"
    >
      <Header />
      <Hero />
      <ProblemSection />
      <PillarsSection />
      <InstituteSection />
      <FidelitySection />
      <PersonasSection />
      <LegalSection />
      <BrasiliaSection />
      <JourneySection />
      <FAQSection />
      <LeadForm />
      <Footer />
    </main>
  );
}
